import { GET_CATALOGO_COBRO_LIST, GET_CATALOGO_COBRO_DETAIL, PUT_CATALOGO_COBRO_EDIT, POST_CATALOGO_COBRO_CREATE, DELETE_CATALOGO_COBRO, ACTIVAR_CATALOGO_COBRO} from "./CatalogoCobroAction";

let initialState = {
    getCatalogoCobroList:           false,
    errorCatalogoCobroList:         false,
    getCatalogoCobroDetail:         false,
    errorCatalogoCobroDetail:       false,
    getResponDataCatalogoCobro:     false,
    errorResponDataCatalogoCobro:   false,
    getResponDataCatalogoCobroC:    false,
    errorResponDataCatalogoCobroC:  false,
    getCatalogoCobroBorrar:         false,
    errorCatalogoCobroBorrar: false,
    getCatalogoCobroActivar: false,
    errorCatalogoCobroActivar: false,
};

const CatalogoCobroReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_CATALOGO_COBRO_LIST:
            return {
                ...state,
                getCatalogoCobroList: action.payload.data,
                errorCatalogoCobroList: action.payload.errorMessage,
            };

        case GET_CATALOGO_COBRO_DETAIL:

            return {
                ...state,
                getCatalogoCobroDetail: action.payload.data,
                errorCatalogoCobroDetail: action.payload.errorMessage,
            };

        case PUT_CATALOGO_COBRO_EDIT:
            return {
                ...state,
                getResponDataCatalogoCobro: action.payload.data,
                errorResponDataCatalogoCobro: action.payload.errorMessage,
            };

        case POST_CATALOGO_COBRO_CREATE:
            return {
                ...state,
                getResponDataCatalogoCobroC: action.payload.data,
                errorResponDataCatalogoCobroC: action.payload.errorMessage,
            };

        case DELETE_CATALOGO_COBRO:
            return {
                ...state,
                getCatalogoCobroBorrar: action.payload.data,
                errorCatalogoCobroBorrar: action.payload.errorMessage,
            };

        case ACTIVAR_CATALOGO_COBRO:
            return {
                ...state,
                getCatalogoCobroActivar: action.payload.data,
                errorCatalogoCobroActivar: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default CatalogoCobroReducer;